import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import useReorderSections from "./useReorderSections";
import { txt } from "../../../services/translation";

export default function useUpdateSection(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', id, 'sections'], [id]);

    const reorderSections = useReorderSections()

    return (section) => {

        let newSection = {...section, edit: false};

        const oldSections = [...queryClient.getQueryData(queryKey)];

        let newSections = [...queryClient.getQueryData(queryKey)].filter(c => c.id !== newSection.id);
        newSections.push(newSection);
        newSections = reorderSections(newSections);
        queryClient.setQueryData(queryKey, newSections);

        newSection = newSections.find(s => s.id === newSection.id);

        API.put(`/design/sections/${newSection.id}`, newSection)
            .then(r => {
                console.log(r)
                API.put(`/design/sections/reorder`, newSections)
            })
            .catch(() => {
                queryClient.setQueryData(queryKey, oldSections)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}